"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncEventEmitter = void 0;
class AsyncEventEmitter {
    constructor() {
        this.listeners = {};
        this.on = (event, listener) => {
            if (!this.listeners[event]) {
                this.listeners[event] = [];
            }
            this.listeners[event].push(listener);
        };
        this.clear = (event) => {
            delete this.listeners[event];
        };
        this.emit = async (event, ...args) => {
            for (const listener of this.listeners[event]) {
                await listener(...args);
            }
        };
    }
}
exports.AsyncEventEmitter = AsyncEventEmitter;
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libs-tools/models/event.js
// module id = 492
// module chunks = 0